webpackJsonp([231026285014322],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"], ["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledImage = _styledComponents2.default.div(_templateObject, function (props) {
	                return "/" + props.imageUrl;
	});
	
	var HeaderImage = function HeaderImage(_ref) {
	                var imageUrl = _ref.imageUrl,
	                    children = _ref.children;
	                return _react2.default.createElement(
	                                StyledImage,
	                                { imageUrl: imageUrl },
	                                " ",
	                                children,
	                                " "
	                );
	};
	
	exports.default = HeaderImage;
	module.exports = exports["default"];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\npadding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   padding-bottom: 1em;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"], ["\npadding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   padding-bottom: 1em;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"]);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = _styledComponents2.default.div(_templateObject);
	
	var StyledCardContainer = function StyledCardContainer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    " ",
	    children,
	    " "
	  );
	};
	
	exports.default = StyledCardContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"], ["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\ntext-decoration: none;\ncolor: black;\n\n"], ["\ntext-decoration: none;\ncolor: black;\n\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: relative;\n  padding-bottom: 56.25%;\n  padding-top: 25px;\n"], ["\n  width: 100%;\n  position: relative;\n  padding-bottom: 56.25%;\n  padding-top: 25px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  scrolling: \"no\";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  scrolling: \"no\";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(44);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content = __webpack_require__(45);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _HeaderImage = __webpack_require__(28);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	var _conferenceDate = __webpack_require__(62);
	
	var _conferenceDate2 = _interopRequireDefault(_conferenceDate);
	
	var _StyledContainer = __webpack_require__(61);
	
	var _StyledContainer2 = _interopRequireDefault(_StyledContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledDiv = _styledComponents2.default.div(_templateObject);
	
	var StyledLink = _styledComponents2.default.a(_templateObject2);
	
	var VideoWrapper = _styledComponents2.default.div(_templateObject3);
	
	var VideoIFrame = _styledComponents2.default.iframe(_templateObject4);
	
	var TalkCards = function (_Component) {
	  _inherits(TalkCards, _Component);
	
	  function TalkCards() {
	    _classCallCheck(this, TalkCards);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TalkCards.prototype.render = function render() {
	    return _react2.default.createElement(
	      StyledDiv,
	      null,
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/gotoCpnSmall.jpg" })
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              " SOLID Elixir "
	            ),
	            _react2.default.createElement(_conferenceDate2.default, { event: "GoTo CPH", date: "October 2018", location: "Copenhagen" }),
	            _react2.default.createElement(
	              VideoWrapper,
	              null,
	              _react2.default.createElement(VideoIFrame, {
	                src: "https://www.youtube.com/embed/rmftOs2BzgU" })
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(_conferenceDate2.default, { event: "Elixir EU", date: "April 2018", location: "Warsaw, Poland" }),
	            _react2.default.createElement(
	              VideoWrapper,
	              null,
	              _react2.default.createElement(VideoIFrame, {
	                src: "https://www.youtube.com/embed/eldYot7uxUc" })
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(_conferenceDate2.default, { event: "Closing key note at Code Beam Lite", date: "April 2018",
	              location: "Milan, Italy" }),
	            _react2.default.createElement("br", null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/cards.jpeg" })
	          ),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              "Elixir: A Mini Documentary"
	            ),
	            _react2.default.createElement(_conferenceDate2.default, { event: "Elixir EU", date: "April 2018", location: "Warsaw, Poland" }),
	            _react2.default.createElement(
	              VideoWrapper,
	              null,
	              _react2.default.createElement(VideoIFrame, { width: "210", height: "182",
	                src: "https://www.youtube.com/embed/lxYFOM3UJzo" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "http://swanseacon.co.uk/archive2017/",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/swansea.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " Don't Diss The Discipline"
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "SwanseaCon", date: "September 2017", location: "Swansea, Wales" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "This talk drew upon experiences seen during my journey to becoming a Software Crafter, I summarised some common traits observed in those developers who made a huge impact on my career, and how I built up my own offering such that I now call myself a Software Crafter."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/ElixirLdnUmbrellaTalk.jpeg" })
	          ),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              "Under The Elixir Umbrella "
	            ),
	            _react2.default.createElement(_conferenceDate2.default, { event: "Elixir Ldn", date: "August 2017", location: "London, UK" }),
	            _react2.default.createElement(
	              VideoWrapper,
	              null,
	              _react2.default.createElement(VideoIFrame, { width: "210", height: "182",
	                src: "https://www.youtube.com/embed/jhZwQ1LTdUI" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://www.meetup.com/Ladies-of-Code-UK/events/236922126/",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/LoCUmbrella.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "Introduction to Elixir "
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "Ladies of Code Meetup", date: "April 2017", location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "This talk went through basic examples and live code demos of some Elixir features."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://www.meetup.com/Ladies-of-Code-UK/events/232609419/",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/TDD2Talk.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "TDD From the Inside Out or the Outside In? "
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "Ladies of Code Meetup", date: "August 2016", location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "This talk compared two different styles of TDD: inside out and outside in."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://getstarted.ticketmaster.co.uk/news/london-technology-week-wrap",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "talks/DiversityTalk.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "Diversity in Technology"
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "London Technology Week", date: "July 2016", location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "This talk shared 8th Light\u2019s journey to creating a gender diverse workplace."
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TalkCards;
	}(_react.Component);
	
	exports.default = TalkCards;
	module.exports = exports["default"];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n padding: 8px;\n"], ["\n padding: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TitleLayout = _styledComponents2.default.div(_templateObject);
	var Layout = _styledComponents2.default.div(_templateObject2);
	var TitleContent = function TitleContent(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      TitleLayout,
	      null,
	      children
	    )
	  );
	};
	
	exports.default = TitleContent;
	module.exports = exports["default"];

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConferenceDetails = function ConferenceDetails(_ref) {
	  var event = _ref.event,
	      location = _ref.location,
	      date = _ref.date;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB ",
	      event
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83D\uDCC5 ",
	      date
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83C\uDF0D ",
	      location
	    )
	  );
	};
	
	exports.default = ConferenceDetails;
	module.exports = exports["default"];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _TalkCards = __webpack_require__(212);
	
	var _TalkCards2 = _interopRequireDefault(_TalkCards);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      _TitleLayout2.default,
	      null,
	      "Over the last few years I have made several public appearances in the form of talks and workshops. Here are details on talks I've done in the Software Community all over Europe."
	    ),
	    _react2.default.createElement("p", null),
	    _react2.default.createElement(_TalkCards2.default, null)
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-talks-js-ea5ce845180ae053de47.js